// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BC-UpgradeTurbo__Dashboard .Polaris-Banner {
    background-color: #FFFBF3;
    padding: 0;
}

.BC-UpgradeTurbo__Dashboard.BC-UpgradeTurbo__Dashboard--turbo .Polaris-Banner {
    background-color: #EBF9FC;
}


.BC-UpgradeTurbo__Dashboard .Polaris-Banner .Polaris-Banner__Ribbon {
    display: none;
}

.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info {
    position: relative;
    padding: 20px;
}

.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info.turbo-banner .actions {
    display: flex;
    gap: 20px;
    align-items: center;
    margin-top: 20px;
}

.BC-UpgradeTurbo__Dashboard .Polaris-Banner:has(.turbo-banner--orange) {
    background-color: #FFFBF3;
}

.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info.turbo-banner .actions .Polaris-Button--plain span {
    text-decoration: underline;
}

.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info.turbo-banner .actions .Polaris-Icon {
    width: 1rem;
    height: 1rem;
}

.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .title {
    display: flex;
    align-items: center;
    gap: 6px;
    font-weight: 600;
    font-size: 20px;
}

.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .title--smaller {
    font-size: 16px;
}

.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .turbo-img {
    position: absolute;
    right: 0;
    top: 0;
}

.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .turbo-img.turbo-img--si {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    bottom: 0;
}

.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info-list {
    margin: 8px 0;
    padding-left: 24px;
    margin-bottom: 24px;
}

.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info-list li {
    line-height: 22px;
}

.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info-cta .Polaris-ButtonGroup__Item:first-child .Polaris-Button {
    background-color: #FFC96B;
    box-shadow: 0px -1px 0px 0px #00000033 inset, 0px 1px 0px 0px #00000014;
}

.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info-cta .Polaris-ButtonGroup__Item:first-child .Polaris-Button:hover {
    background-color: #f3be63;
}

.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .banner-info-cta.banner-info-cta--collapsed {
    margin-top: 20px;
}

.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .banner-info-cta.banner-info-cta--outline {
    padding-left: 4px;
}

.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .banner-info-cta.banner-info-cta--outline .Polaris-ButtonGroup__Item:last-child {
    margin-left: 20px;
}

.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .banner-info-cta.banner-info-cta--outline .Polaris-ButtonGroup__Item:first-child .Polaris-Button {
    background-color: transparent;
    box-shadow: 0px 1px 0px 0px #0000000D;
    border-color: #98C6CD;
}

.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .banner-info-cta.banner-info-cta--outline .Polaris-ButtonGroup__Item:first-child .Polaris-Button:hover {
    background-color: #e3f2f5;
}

.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .banner-info-cta.banner-info-cta--outline .Polaris-ButtonGroup__Item:last-child .Polaris-Button__Text {
    display: flex;
    align-items: center;
    gap: 2px;
}

.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .banner-action {
    position: absolute;
    top: 20px;
    right: 24px;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 20px;
    width: 50px;
}

.BC-UpgradeTurbo__Dashboard.BC-UpgradeTurbo__Dashboard--turbo .Polaris-Banner .banner-info .banner-action {
    width: 20px;
    height: 20px;
}

.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .banner-action>div:first-child {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
}


.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .banner-action .Polaris-Button {
    padding: 0;
    width: 20px;
    min-width: unset;
    min-height: unset;
    display: block;
}

.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .banner-action .Polaris-Icon__Svg {
    fill: #5C5F62;
}

.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .banner-extra {
    position: absolute;
    bottom: 27px;
    right: 20px;
    z-index: 10;
}


.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .banner-extra p {
    display: flex;
    align-items: center;
    color: rgb(109, 113, 117);
}

.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .banner-extra .Polaris-Link {
    display: flex;
    align-items: center;
    margin: 0 4px;
    margin-left: 6px;
    color: rgb(0, 91, 211);
}

.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .banner-extra .Polaris-Icon {
    margin: 0;
    margin-left: 4px;
}

.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .banner-extra .Polaris-Icon__Svg {
    fill: rgb(0, 91, 211);
}

.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .banner-info-manage {
    margin-bottom: 16px;
    padding-left: 4px;
}

.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .banner-info-manage p,
.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .banner-info-manage p span {
    display: flex;
    align-items: center;
    gap: 4px;
}

.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .banner-info-manage p span {
    font-weight: 500;
    position: relative;
    top: 1px;
}

.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .banner-info-manage .Polaris-Icon__Svg {
    fill: #5C5F62;
}


.BC-Page__Theme-Setup .BC-UpgradeTurbo__Dashboard,
.BC-Page__ShopifyIntegration .BC-UpgradeTurbo__Dashboard {
    margin-bottom: 24px;
}

.BC-UpgradeTurbo__Campaign {
    position: relative;
    margin-bottom: 24px;
}

.BC-UpgradeTurbo__Campaign .Polaris-Banner--statusInfo {
    background: #EBF9FC;
    border-color: #98C6CD;
}

.BC-UpgradeTurbo__Campaign .Polaris-Banner .banner-info .title {
    display: flex;
    align-items: center;
    gap: 6px;
    font-weight: 600;
    font-size: 16px;
}

.BC-UpgradeTurbo__Campaign .Polaris-Banner .banner-info .Polaris-Link {
    display: inline-flex;
    align-items: center;
    color: #2c6ecb !important;
    gap: 2px;
}

.BC-UpgradeTurbo__Campaign .Polaris-Banner .banner-info .Polaris-Link .Polaris-Icon {
    margin: 0;
    width: 16px;
    height: 16px;
}

.BC-UpgradeTurbo__Campaign .Polaris-Banner .banner-info .Polaris-Link .Polaris-Icon__Svg {
    fill: #2c6ecb;
}

.BC-UpgradeTurbo__Campaign .Polaris-Banner .banner-info .banner-action {
    position: absolute;
    top: 20px;
    right: 20px;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 20px;
}

.BC-UpgradeTurbo__Campaign .Polaris-Banner .banner-info .banner-action .Polaris-Button {
    padding: 0;
    width: 20px;
    height: 20px;
    min-width: auto;
    min-height: auto;
}

.BC-UpgradeTurbo__Campaign .Polaris-Banner .banner-info .banner-action .Polaris-Icon__Svg {
    fill: #5C5F62;
}

.BC-UpgradeTurbo__Campaign .Polaris-Banner .banner-info .guide-list {
    margin-top: 0;
    padding-left: 16px;
}`, "",{"version":3,"sources":["webpack://./src/styles/banner.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,UAAU;AACd;;AAEA;IACI,yBAAyB;AAC7B;;;AAGA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,MAAM;AACV;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,QAAQ;IACR,2BAA2B;IAC3B,SAAS;AACb;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,uEAAuE;AAC3E;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,6BAA6B;IAC7B,qCAAqC;IACrC,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;AAChB;;;AAGA;IACI,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,WAAW;AACf;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,aAAa;AACjB;;;AAGA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,yBAAyB;IACzB,QAAQ;AACZ;;AAEA;IACI,SAAS;IACT,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,SAAS;AACb;;AAEA;IACI,UAAU;IACV,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB","sourcesContent":[".BC-UpgradeTurbo__Dashboard .Polaris-Banner {\n    background-color: #FFFBF3;\n    padding: 0;\n}\n\n.BC-UpgradeTurbo__Dashboard.BC-UpgradeTurbo__Dashboard--turbo .Polaris-Banner {\n    background-color: #EBF9FC;\n}\n\n\n.BC-UpgradeTurbo__Dashboard .Polaris-Banner .Polaris-Banner__Ribbon {\n    display: none;\n}\n\n.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info {\n    position: relative;\n    padding: 20px;\n}\n\n.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info.turbo-banner .actions {\n    display: flex;\n    gap: 20px;\n    align-items: center;\n    margin-top: 20px;\n}\n\n.BC-UpgradeTurbo__Dashboard .Polaris-Banner:has(.turbo-banner--orange) {\n    background-color: #FFFBF3;\n}\n\n.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info.turbo-banner .actions .Polaris-Button--plain span {\n    text-decoration: underline;\n}\n\n.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info.turbo-banner .actions .Polaris-Icon {\n    width: 1rem;\n    height: 1rem;\n}\n\n.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .title {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-weight: 600;\n    font-size: 20px;\n}\n\n.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .title--smaller {\n    font-size: 16px;\n}\n\n.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .turbo-img {\n    position: absolute;\n    right: 0;\n    top: 0;\n}\n\n.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .turbo-img.turbo-img--si {\n    position: absolute;\n    right: 0;\n    top: 50%;\n    transform: translateY(-50%);\n    bottom: 0;\n}\n\n.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info-list {\n    margin: 8px 0;\n    padding-left: 24px;\n    margin-bottom: 24px;\n}\n\n.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info-list li {\n    line-height: 22px;\n}\n\n.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info-cta .Polaris-ButtonGroup__Item:first-child .Polaris-Button {\n    background-color: #FFC96B;\n    box-shadow: 0px -1px 0px 0px #00000033 inset, 0px 1px 0px 0px #00000014;\n}\n\n.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info-cta .Polaris-ButtonGroup__Item:first-child .Polaris-Button:hover {\n    background-color: #f3be63;\n}\n\n.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .banner-info-cta.banner-info-cta--collapsed {\n    margin-top: 20px;\n}\n\n.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .banner-info-cta.banner-info-cta--outline {\n    padding-left: 4px;\n}\n\n.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .banner-info-cta.banner-info-cta--outline .Polaris-ButtonGroup__Item:last-child {\n    margin-left: 20px;\n}\n\n.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .banner-info-cta.banner-info-cta--outline .Polaris-ButtonGroup__Item:first-child .Polaris-Button {\n    background-color: transparent;\n    box-shadow: 0px 1px 0px 0px #0000000D;\n    border-color: #98C6CD;\n}\n\n.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .banner-info-cta.banner-info-cta--outline .Polaris-ButtonGroup__Item:first-child .Polaris-Button:hover {\n    background-color: #e3f2f5;\n}\n\n.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .banner-info-cta.banner-info-cta--outline .Polaris-ButtonGroup__Item:last-child .Polaris-Button__Text {\n    display: flex;\n    align-items: center;\n    gap: 2px;\n}\n\n.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .banner-action {\n    position: absolute;\n    top: 20px;\n    right: 24px;\n    z-index: 10;\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 20px;\n    width: 50px;\n}\n\n.BC-UpgradeTurbo__Dashboard.BC-UpgradeTurbo__Dashboard--turbo .Polaris-Banner .banner-info .banner-action {\n    width: 20px;\n    height: 20px;\n}\n\n.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .banner-action>div:first-child {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 20px;\n    height: 20px;\n}\n\n\n.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .banner-action .Polaris-Button {\n    padding: 0;\n    width: 20px;\n    min-width: unset;\n    min-height: unset;\n    display: block;\n}\n\n.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .banner-action .Polaris-Icon__Svg {\n    fill: #5C5F62;\n}\n\n.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .banner-extra {\n    position: absolute;\n    bottom: 27px;\n    right: 20px;\n    z-index: 10;\n}\n\n\n.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .banner-extra p {\n    display: flex;\n    align-items: center;\n    color: rgb(109, 113, 117);\n}\n\n.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .banner-extra .Polaris-Link {\n    display: flex;\n    align-items: center;\n    margin: 0 4px;\n    margin-left: 6px;\n    color: rgb(0, 91, 211);\n}\n\n.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .banner-extra .Polaris-Icon {\n    margin: 0;\n    margin-left: 4px;\n}\n\n.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .banner-extra .Polaris-Icon__Svg {\n    fill: rgb(0, 91, 211);\n}\n\n.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .banner-info-manage {\n    margin-bottom: 16px;\n    padding-left: 4px;\n}\n\n.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .banner-info-manage p,\n.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .banner-info-manage p span {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n}\n\n.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .banner-info-manage p span {\n    font-weight: 500;\n    position: relative;\n    top: 1px;\n}\n\n.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .banner-info-manage .Polaris-Icon__Svg {\n    fill: #5C5F62;\n}\n\n\n.BC-Page__Theme-Setup .BC-UpgradeTurbo__Dashboard,\n.BC-Page__ShopifyIntegration .BC-UpgradeTurbo__Dashboard {\n    margin-bottom: 24px;\n}\n\n.BC-UpgradeTurbo__Campaign {\n    position: relative;\n    margin-bottom: 24px;\n}\n\n.BC-UpgradeTurbo__Campaign .Polaris-Banner--statusInfo {\n    background: #EBF9FC;\n    border-color: #98C6CD;\n}\n\n.BC-UpgradeTurbo__Campaign .Polaris-Banner .banner-info .title {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-weight: 600;\n    font-size: 16px;\n}\n\n.BC-UpgradeTurbo__Campaign .Polaris-Banner .banner-info .Polaris-Link {\n    display: inline-flex;\n    align-items: center;\n    color: #2c6ecb !important;\n    gap: 2px;\n}\n\n.BC-UpgradeTurbo__Campaign .Polaris-Banner .banner-info .Polaris-Link .Polaris-Icon {\n    margin: 0;\n    width: 16px;\n    height: 16px;\n}\n\n.BC-UpgradeTurbo__Campaign .Polaris-Banner .banner-info .Polaris-Link .Polaris-Icon__Svg {\n    fill: #2c6ecb;\n}\n\n.BC-UpgradeTurbo__Campaign .Polaris-Banner .banner-info .banner-action {\n    position: absolute;\n    top: 20px;\n    right: 20px;\n    z-index: 10;\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 20px;\n}\n\n.BC-UpgradeTurbo__Campaign .Polaris-Banner .banner-info .banner-action .Polaris-Button {\n    padding: 0;\n    width: 20px;\n    height: 20px;\n    min-width: auto;\n    min-height: auto;\n}\n\n.BC-UpgradeTurbo__Campaign .Polaris-Banner .banner-info .banner-action .Polaris-Icon__Svg {\n    fill: #5C5F62;\n}\n\n.BC-UpgradeTurbo__Campaign .Polaris-Banner .banner-info .guide-list {\n    margin-top: 0;\n    padding-left: 16px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
